import { render, staticRenderFns } from "./departmental_performance.vue?vue&type=template&id=11fd2c57&scoped=true&"
import script from "./departmental_performance.vue?vue&type=script&lang=js&"
export * from "./departmental_performance.vue?vue&type=script&lang=js&"
import style0 from "./departmental_performance.vue?vue&type=style&index=0&id=11fd2c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd2c57",
  null
  
)

export default component.exports